import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mlb/react-patterns/components/Button/button.tsx';

import { Tracking } from 'bdvp-tracking';

const PlayPauseButton = (props) => {

    const {
        paused,
        mediaPlayer,
        setWasPlaying,
    } = props;

    const ariaLabel = paused ? 'Play' : 'Pause';
    const iconName = paused ? 'play' : 'pause';

    return (
        <Button
            size={'md'}
            styleName={'default'}
            shape={'hollow-borderless'}
            hasHover={false}
            ariaLabel={ariaLabel}
            iconName={iconName}
            handlers={{
                onClick: () => {

                    Tracking.trackReelCreationEventButtonClick(ariaLabel);

                    if(paused) {

                        mediaPlayer.play();
                        setWasPlaying(true);

                    } else {

                        mediaPlayer.pause();
                        setWasPlaying(false);

                    }

                },
            }}
        />
    );

};

PlayPauseButton.propTypes = {
    paused: PropTypes.bool.isRequired,
    setWasPlaying: PropTypes.func.isRequired,
    mediaPlayer: PropTypes.object,
};

PlayPauseButton.defaultProps = {
    mediaPlayer: {},
};

export default PlayPauseButton;
